import {
  Action,
  DataContainer,
  Feature,
  MiniAction,
  submitMerge,
  submitMiniAction,
  submitMove,
  trackOnNextPageImpression,
} from "@otto-ec/tracking-bct";
import { TileType, TrackingFeatureStatus } from "./types";

export class TrackingService {
  sendInitialLoadedTrackingEvent(
    targetPSR: string,
    tileType: TileType,
    brandName: string,
  ) {
    const trackingFeatures = [
      this.createBrandspotlightTrackingFeature("loaded", tileType),
    ];
    trackingFeatures.push(
      this.createBrandspotlightPromoTileTrackingFeature(
        "loaded",
        targetPSR,
        brandName,
      ),
    );
    submitMerge({}, trackingFeatures);
  }

  sendVisibleTrackingEvent() {
    const brandspotlightFeatureMiniAction =
      this.createBrandspotlightFeatureMiniAction();
    const brandspotlightTileFeatureMiniAction =
      this.createBrandspotlightTileFeatureMiniAction();
    submitMiniAction([
      brandspotlightFeatureMiniAction,
      brandspotlightTileFeatureMiniAction,
    ]);
  }

  sendClickTrackingEvent(
    targetPSR: string,
    tileType: TileType,
    brandName: string,
  ) {
    const featureTrackingData: Action = {
      name: "click",
      features: [
        this.createBrandspotlightTrackingFeature("clicked", tileType),
        this.createBrandspotlightPromoTileTrackingFeature(
          "clicked",
          targetPSR,
          brandName,
        ),
      ],
    };
    const wkTrackingData: DataContainer = this.createWkTrackingData();
    submitMove(wkTrackingData, featureTrackingData);

    const nextPiTrackingLabels = {
      promo_Click: ["BrandSpotlightPromo"],
      product_BrandLogo: ["clicked"],
      "wk.product_BrandLogoClicked": [brandName],
    };
    trackOnNextPageImpression(nextPiTrackingLabels);
  }

  private createWkTrackingData(): DataContainer {
    return {
      "wk.promo_AttributionFeature": ["BrandSpotlightPromo_Artikeldetailseite"],
      "wk.promo_AttributionSource": ["brandcalc"],
      product_BrandLogo: ["click"],
    };
  }

  private createBrandspotlightTrackingFeature(
    status: TrackingFeatureStatus,
    tileType: TileType,
  ): Feature {
    return {
      id: "ft3_brandspotlight",
      name: "BrandSpotlightPromo",
      status: status,
      labels: {
        promo_TileType: [this.getTileTypeValue(tileType)],
        promo_Feature: ["true"],
      },
    };
  }

  private createBrandspotlightPromoTileTrackingFeature(
    status: TrackingFeatureStatus,
    targetPSR: string,
    brandName: string,
  ): Feature {
    return {
      id: "ft3_brandspotlight_tile",
      position: 1,
      name: "BrandSpotlightPromo-Tile",
      parentId: "ft3_brandspotlight",
      status: status,
      labels: {
        promo_Source: ["brandcalc"],
        promo_Brand: [brandName],
        promo_TargetPSRBrand: [targetPSR],
      },
    };
  }

  private getTileTypeValue(tileType: TileType) {
    if (tileType === "premium") {
      return "Premium";
    } else {
      return "Basic";
    }
  }

  private createBrandspotlightFeatureMiniAction(): MiniAction {
    /*                                                              */
    return {
      featureId: "ft3_brandspotlight",
    };
  }

  private createBrandspotlightTileFeatureMiniAction(): MiniAction {
    /*                                                              */
    return {
      featureId: "ft3_brandspotlight_tile",
    };
  }
}
